import type { Middleware } from 'openapi-fetch';

/*
 * URL rewriting for prod vs. proxy (spec §3.3).
 * openapi-fetch builds a request URL from a possibly-relative baseUrl. The
 * browser Fetch tolerates a relative URL, but undici (node, used under jsdom in
 * tests) rejects it. Rewrite any origin-relative request to an absolute URL
 * against the current origin, resolved at request time (not module-eval time).
 */
export const baseUrlMiddleware: Middleware = {
  onRequest({ request }) {
    if (request.url.startsWith('/')) {
      const origin =
        typeof window !== 'undefined' ? window.location.origin : undefined;
      if (origin) {
        return new Request(new URL(request.url, origin), request);
      }
    }
    return request;
  },
};
